export const limitFileSize = 1024 * 1024 * 5; //1 MB

export function failRequestHandler(message) {
  console.log(message);
}
